(function () {
  'use strict';

  angular.module('ringbaPortal').component('newBreak', {
    bindings: {
      isMeridian: '<',
      onAdd: '&',
      onDismiss: '&'
    },

    controller: NewBreakController,
    controllerAs: 'vm',
    templateUrl: '/scripts/shared/components/concurrency-schedule/schedule-breaks/new-break.view.html'
  });

  function NewBreakController(
    hoursScheduleService
  ) {
    'ngInject';

    const vm = this;

    vm.$onInit = onInit;
    vm.dismiss = dismiss;
    vm.saveBreak = saveBreak;
    vm.checkDayTime = hoursScheduleService.checkDayTime;

    vm.isMeridian = true;
    vm.showAdvancedHours = false;

    function onInit() {
      _initializeBreak();
    }

    function saveBreak() {
      vm.breakToAdd.startTime = {
        hour: vm.startTime.getHours(),
        minute: vm.startTime.getMinutes(),
      };
      vm.onAdd({
        $event: {
          break: vm.breakToAdd
        }
      });
      dismiss();
    }

    function _initializeBreak() {
      vm.breakToAdd = {
        lengthInMin: 45
      };
      vm.startTime = new Date();
      vm.startTime.setHours(12);
      vm.startTime.setMinutes(0);
    }

    function dismiss() {
      _initializeBreak();
      vm.onDismiss({
        $event: {
          dismiss: true
        }
      });
    }

  }

})();
